import { toRaw } from 'vue';
import {
  FormValidator,
  type FormValidatorContext,
  type FormValidatorConfig,
  type FormValidatorSettings,
  isEmpty
} from '@common';

export interface HarvestDateValidatorSettings extends FormValidatorSettings {
  otherFieldName: string;
  allowEqual: boolean;
}

export type HarvestDateValidatorConfig = FormValidatorConfig<HarvestDateValidatorSettings>;

export class HarvestDateValidator extends FormValidator<HarvestDateValidatorSettings> {
  constructor() {
    super();
    this._name = 'harvestDate';
    this._settings = {
      invalidMessage: 'parcel.details.validator.harvestDate.invalidMessage',
      needTranslate: true,
      otherFieldName: 'sowingDate',
      allowEqual: false
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const values = toRaw(context.element.parent?.value);
    const otherValue = values[this.settings.otherFieldName];
    if (otherValue) {
      const date = new Date(value);
      const otherDate = new Date(otherValue);
      this._valid = this.settings.allowEqual ? date >= otherDate : date > otherDate;
      if (!this._valid) {
        this.addMessage(this.settings.invalidMessage);
      }
    }
  }
}
